
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormatDataTableGlobal, FormatDataTableGlobalFive, GetPermisses } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';
import { ApiServiceProject } from '../../apis/ApiServiceProject';
import { ApiServiceERP } from '../../apis/ApiServiceERP';
import { ApiServiceApi } from '../../apis/ApiServiceAPI';

@Component({
  selector: 'app-generate-payroll-excel',
  templateUrl: './generate-payroll-excel.component.html',
  styleUrls: ['./generate-payroll-excel.component.scss']
})
export class GeneratePayrollExcelComponent implements OnInit {

  Step4form: FormGroup;
  Step2form: FormGroup;
  file: File
  fileName = ''
  extension = ''
  nombrepost
  today = new Date().toISOString().split('T')[0];
  listYear = [];
  syncTaas = true
  planillaGenerate = true

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private errorService: ErrorService,
    private apiService: ApiServiceERP, 
    private apiServiceApi: ApiServiceApi
  ) {

    this.Step4form = this.fb.group({
      project_type: [''],
      start_date: [''],
      archive: '',
      extend_date: false
    });
    
    this.Step2form = this.fb.group({
      project_type: [''],
      start_date: [''],
    });
  }


  ngOnInit(): void {
  this.syncTaas = GetPermisses(60);
  this.planillaGenerate = GetPermisses(58);

  let yearActual = moment(new Date()).format('YYYY');
  let endYear = Number(yearActual) + 2;
   for(let i = endYear; 2009 != i; i--){
    let info ={
      id: i,
      name: i
    }
    this.listYear.push(info)
   }

  }

onFileSelected(event: any) {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) {
    return;
  }

  this.file = input.files[0];

  const maxSize = 5 * 1024 * 1024; // 5 MB

  if (this.file.size > maxSize) {
    Swal.fire({ title: 'El archivo supera el tamaño máximo permitido (5 MB).', text: '', icon: 'error', heightAuto: false });
    // limpiar
    this.file = null;
    this.fileName = '';
    this.extension = '';
    this.nombrepost = '';
    input.value = '';

    return;
  }

  this.fileName = this.file.name;

  const parts = this.fileName.split('.');
  this.extension = parts[parts.length - 1];
  this.nombrepost = this.fileName.slice(0, -(this.extension.length + 1));
}


  formSubmit() {
    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
      form.classList.add('was-validated');
    } else {
      this.spinner.show();
      
      const formatted = moment(this.Step4form.value.start_date).format('DD-MM-YYYY');
      let url = "dowload-generate-payroll-taas-excel"
      if(this.Step4form.value.project_type == 3){
        url = "dowload-generate-payroll-global-excel"
      }

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("type", this.Step4form.value.project_type);
      formData.append("inputDate", formatted);
      this.apiService.postServiceDownload(url, formData).subscribe({
        next: (rs) => {
          let dataType = rs.type;
          let ext = dataType.split('/')
          let binaryData = [];
          binaryData.push(rs);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (ext[1] != null) {
            downloadLink.setAttribute('download', 'document.' + ext[1]);
          }
          this.spinner.hide();
          document.body.appendChild(downloadLink);
          downloadLink.click();
           Swal.fire({title:'Exito!',text: 'Se ha generado el archivo con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
        },
        error: (error) => {
          const errorJson = JSON.parse(this.blobToString(error.error));
          if (errorJson.code == 1) {
            this.spinner.hide()
            Swal.fire({ title: errorJson.error, text: '', icon: 'error', heightAuto: false });
          } else {
            this.spinner.hide()
            this.errorService.error(error);
          }
        },
      })
    }

  }

  private blobToString(blob): string {
    const url = URL.createObjectURL(blob);
    let xmlRequest = new XMLHttpRequest();
    xmlRequest.open('GET', url, false);
    xmlRequest.send();
    URL.revokeObjectURL(url);
    return xmlRequest.responseText;
  }


  formSubmitProject() {

    var form = document.getElementsByClassName('needs-validation-2')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
      form.classList.add('was-validated');
    } else {
      this.spinner.show();

      this.apiService.DownloadService('dowload-generate-project-excel?type='+this.Step2form.value.project_type+'&date='+this.Step2form.value.start_date+'').subscribe({
          next: (rs) => {
          let dataType = rs.type;
          let ext = dataType.split('/')
          let binaryData = [];
          binaryData.push(rs);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (ext[1] != null) {
            downloadLink.setAttribute('download', 'document.' + ext[1]);
          }
          this.spinner.hide();
          document.body.appendChild(downloadLink);
          downloadLink.click();
           Swal.fire({title:'Exito!',text: 'Se ha generado el archivo con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
        },
        error: (error) => {
          const errorJson = JSON.parse(this.blobToString(error.error));
          if (errorJson.code == 1) {
            this.spinner.hide()
            Swal.fire({ title: errorJson.error, text: '', icon: 'error', heightAuto: false });
          } else {
            this.spinner.hide()
            this.errorService.error(error);
          }
        },
        })
    }
  }

  Sync(){
    Swal.fire({
              title: 'Sincronizar',
              text: '¿Desea sincronizar planilla?',
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
     this.spinner.show()
       this.apiServiceApi.getService('excel-async_taas').subscribe({
          next: (rs:any) => {
    
            if (rs.code == null) {
              this.spinner.hide();
              Swal.fire({
                title: rs.message,
                text: '',
                icon: 'success',
                heightAuto: false
              });
            } else {
              this.spinner.hide();
              Swal.fire({
                title: rs.error,
                text: '',
                icon: 'error',
                heightAuto: false
              });
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
      });

  }


}


